import { ReactNode } from 'react';
import { useMatch } from 'react-router-dom';

import { Box } from '@mui/material';
import { BottomGradientBar, BrandLogo, LegalConsentNote } from '@components';
import { AppRoutes } from '@constants';

export const AuthLayout = ({ children }: { children: ReactNode }) => {
  const isSignIn = Boolean(useMatch(`/${AppRoutes.SIGN_IN}`));
  const signInNote = (
    <LegalConsentNote lead="By signing in, you agree to the" />
  );

  return (
    <Box
      height="100dvh"
      width="100%"
      display="flex"
      flexDirection="column"
      bgcolor={{ xs: 'common.white', md: 'background.backgroundPrimary' }}
      position="relative"
    >
      <Box
        sx={{
          position: { xs: 'relative', md: 'absolute' },
          top: 0,
          left: 0,
        }}
        pt={{ xs: 2, md: 3 }}
        pl={{ xs: 2, md: 6 }}
      >
        <BrandLogo />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        flex={1}
      >
        <Box
          sx={{
            maxWidth: { xs: '100%', md: '570px' },
            width: '100%',
            margin: { xs: '0', md: '16px 24px' },
            borderRadius: { xs: '0', md: '16px' },
            flex: { xs: 1, md: 'none' },
            boxShadow: { xs: 'none', md: '0px 8px 16px 0px #8F95B226' },
            display: 'flex',
            flexDirection: 'column',
            bgcolor: 'common.white',
          }}
        >
          <Box
            sx={{ padding: { xs: '36px 16px 16px 16px', md: '63px 58px' } }}
            flex={1}
          >
            {children}
            {/* On a phone the card is the whole screen and snackbars cover its bottom edge, so
                the line closes the card's content instead. */}
            {isSignIn && (
              <Box display={{ xs: 'block', md: 'none' }} mt={4}>
                {signInNote}
              </Box>
            )}
          </Box>
          <BottomGradientBar />
        </Box>
        {/* Under the card, in line with its content (Figma: client > login). */}
        {isSignIn && (
          <Box
            display={{ xs: 'none', md: 'block' }}
            width="100%"
            maxWidth="570px"
            px={7.5}
            pt={0.5}
          >
            {signInNote}
          </Box>
        )}
      </Box>
    </Box>
  );
};
